import { getFeatureFlag } from '@/shared/hooks/use-feature-flag';
import { ErrorLogger } from '@/shared/service/logger/ErrorLogger';

import { type Method } from '../types';

export type Responder = (payload: {
  method: Method;
  value?: any;
  [key: string]: any;
}) => void;

export const respondWithMessage = (
  responder: Window,
  targetOrigin: string = '*'
): Responder => {
  return (payload: { method: Method; value?: any; [key: string]: any }) => {
    const { isTestUser, isKassir } = getFeatureFlag();
    if (isTestUser || isKassir) {
      console.warn('[TO GAME] POST MESSAGE: ', payload);
    }

    try {
      responder.postMessage({ playdeck: payload }, targetOrigin);
    } catch (error) {
      ErrorLogger.error(error as Error, 'func respondWithMessage', {
        payload,
      });
    }
  };
};
